<script setup lang="ts">
import FileUpload from 'primevue/fileupload'
import { ref } from 'vue'
import { useToast } from 'primevue/usetoast'

defineProps<{
  disabled?: boolean
}>()

const emit = defineEmits(['update:modelValue'])
const resetKey = ref(0)
const toast = useToast()

const handleFileUpload = (event: any) => {
  if (event.files && event.files.length > 0) {
    emit('update:modelValue', event.files[0])

    toast.add({
      severity: 'success',
      summary: 'Upload Successful',
      detail: `File "${event.files[0].name}" uploaded successfully!`,
      life: 3000,
    })

    resetKey.value++
  }
};
</script>

<template>
  <div>
    <FileUpload
        :key="resetKey"
        mode="basic"
        :disabled="disabled"
        accept="application/pdf,image/*"
        :auto="false"
        :customUpload="true"
        @select="handleFileUpload"
        chooseLabel="Upload File"
    />
  </div>
</template>